import { channels } from "@/mocks/gossip";

export default function Channels() {
  return (
    <section id="channels" className="scroll-mt-28 border-y border-background-200 bg-background-100/60 py-12 md:py-16">
      <div className="mx-auto max-w-6xl px-4 md:px-6">
        <div className="max-w-2xl">
          <span className="text-xs font-bold uppercase tracking-widest text-accent-700">Topics</span>
          <h2 className="mt-2 font-heading text-3xl font-black tracking-tight text-foreground-950 md:text-4xl">
            六个题材频道，各有一片瓜田
          </h2>
          <p className="mt-3 text-sm leading-7 text-foreground-600">
            每个频道都用同一套深扒标准在经营：可溯源的时间线 + 交叉验证的信源 + 敢于留白的结论。
          </p>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {channels.map((ch) => (
            <a
              key={ch.id}
              href="#featured"
              className="group rounded-2xl border border-background-200 bg-background-50 p-5 transition-colors hover:border-primary-200"
            >
              <div className="flex items-start justify-between">
                <span className="flex h-12 w-12 items-center justify-center rounded-xl bg-primary-100 text-primary-700 transition-colors group-hover:bg-primary-500 group-hover:text-background-50">
                  <i className={`${ch.icon} h-6 w-6`}></i>
                </span>
                <span className="rounded-full bg-background-100 px-2.5 py-1 text-xs font-semibold text-foreground-600">
                  {ch.count}
                </span>
              </div>
              <h3 className="mt-4 font-heading text-lg font-bold text-foreground-950">{ch.label}</h3>
              <p className="mt-1.5 text-sm leading-6 text-foreground-600">{ch.desc}</p>
              <span className="mt-4 inline-flex items-center gap-1 text-sm font-semibold text-primary-600 opacity-0 transition-opacity group-hover:opacity-100">
                进入频道
                <i className="ri-arrow-right-line h-4 w-4"></i>
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}